module.exports = __webpack_public_path__ + "img/imageGallery.ebdd4b54.jpg";